import { useStoreValue } from 'state/hooks/useStore';
import { useCloudfrontLocationQuery } from 'state/hooks/useCloudfrontLocation';
import { StoreEnum } from 'schema/storeCode';

export function useUnfortunateWayToAppendCurrency() {
  const { data: cloudfrontLocation } = useCloudfrontLocationQuery();
  const store = useStoreValue();

  const shouldAppendUSD = (amount?: string | number) =>
    amount &&
    amount?.toString().toLowerCase() !== 'free' &&
    amount !== '---' &&
    cloudfrontLocation?.country &&
    cloudfrontLocation?.country !== 'US' &&
    store === StoreEnum.us;

  const conditionallyAppendUSDtoPrice = (amount?: string | number) => {
    if (shouldAppendUSD(amount)) {
      return `${amount} USD`;
    }
    return amount;
  };

  function wrapUSDInSpan(text?: string, className?: string) {
    if (text && typeof text === 'string') {
      const matchArray = text?.match(/\d+(?:\.\d+)? USD/g);

      if (matchArray) {
        let newString = text || '';

        matchArray.forEach((price) => {
          const amount = price.replace(' USD', '');
          const wrappedPrice = `${amount} <span class="${className}">USD</span>`;
          newString = newString?.replace(price, wrappedPrice);
        });

        // Wrap the entire output in a parent <span> and render as JSX
        // eslint-disable-next-line react/no-danger
        return <span dangerouslySetInnerHTML={{ __html: newString }} />;
      }
    }

    return <span>{text} </span>;
  }

  const conditionallyAppendUSDtoSanityPrice = (text: any) => {
    const sanityAmount = text?.[0]?.children?.[0]?.text;
    // RegEx matches only prices in format: $25, $25.30
    const isSanityPrice = (inputString: string) => /\$\d+(?:.(\d+))?$/.test(inputString);

    if (sanityAmount && isSanityPrice(sanityAmount)) {
      const newText = [...text];

      const newAmount = conditionallyAppendUSDtoPrice(sanityAmount);
      newText[0].children[0].text = newAmount;

      return newText;
    }

    return text;
  };

  const conditionallyAppendUSDtoParsedString = (text: string) => {
    // RegEx matches only prices in format: $25, $25.30
    const matchArray = text.match(/\$\d+(?:.(\d+))?/g);

    if (matchArray) {
      let newString = text;

      matchArray.forEach((price) => {
        const newPrice = conditionallyAppendUSDtoPrice(price);

        if (newPrice && price !== newPrice) {
          newString = newString.replace(price, newPrice as string);
        }
      });
      return newString;
    }

    return text;
  };

  return {
    wrapUSDInSpan,
    shouldAppendUSD,
    conditionallyAppendUSDtoPrice,
    conditionallyAppendUSDtoSanityPrice,
    conditionallyAppendUSDtoParsedString
  };
}
